// KEEP FIRST-LEVEL KEYS IN ALPHABETIC ORDER
export const labelPlaceholderMessageMap = {
	knowledgeTree: {
		view: {
			saved: "Views"
		}
	}
};